<template>
  <div>
    <list-users @create="create()" @update="update" @remove="remove" />
    <form-user
      @close="close()"
      :Edit="edit"
      :modal="modal"
      :external-action="action"
      :external-user="userSend"
    />
  </div>
</template>

<script>
import listUsers from './list'
import formUser from './formManager'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'users',
  components: {
    listUsers,
    formUser
  },
  data() {
    return {
      modal: false,
      action: 'create',
      edit: true
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    ...mapState({
      userSend: state => state.users.userSelected,
      statusOfButton: state => state.events.status
    })
  },
  methods: {
    ...mapActions({
      countryInit: 'countries/setInit',
      provinceInit: 'provinces/setInit',
      cityInit: 'cities/setInit',
      rolInit: 'rols/setInit',
      entityInit: 'entities/setInitSelect',
      teamInit: 'teams/setInitSelect',
      tournamentInit: 'tournaments/setInitSelect',
      usersInit: 'users/setInit',
      getOne: 'users/setOne',
      clearOne: 'users/setClearOne',
      setStatus: 'events/setStatus'
    }),
    create() {
      this.clearOne()
      this.action = 'create'
      this.edit = true
      this.nextTick(_ => {
        this.modal = true
      })
    },
    update(id) {
      this.clearOne()
      this.getOne(id).then(_ => {
        this.action = 'update'
        this.edit = true
        this.nextTick(_ => {
          this.modal = true
        })
      })
    },
    remove(id) {
      this.clearOne()
      this.getOne(id).then(_ => {
        this.action = 'remove'
        this.edit = false
        this.nextTick(_ => {
          this.modal = true
        })
      })
    },
    close() {
      this.modal = false
      this.nextTick(_ => {
        this.clearOne()
      })
    },
    async initData() {
      await Promise.all([
        this.usersInit(),
        this.rolInit(),
        this.countryInit(),
        this.provinceInit(),
        this.cityInit(),
        this.entityInit(),
        this.teamInit(),
        this.tournamentInit()
      ])
    }
  },
  watch: {
    statusOfButton: function(val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    }
  }
}
</script>
